import { render } from "./FrisbuySrInstagram.vue?vue&type=template&id=e348e866&scoped=true"
import script from "./FrisbuySrInstagram.vue?vue&type=script&lang=js"
export * from "./FrisbuySrInstagram.vue?vue&type=script&lang=js"

import "./FrisbuySrInstagram.vue?vue&type=style&index=0&id=e348e866&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e348e866"]])

export default __exports__